import React from 'react';
import classNames from 'classnames';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';

const MachineSizeSelection = (props) => {
  const {
    machineSizes,
    selectedMachineSizeDisplay,
    onBack,
    onNext,
    onValueChange,
    selectedMachineSize,
  } = props;

  return (
    <>
      <header className={styles.header}>
        <h4>Choose your machine's size</h4>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>Select the size/capacity of the machine</p>
          <Autocomplete
            disablePortal
            id="autocomplete-choose-machine-capacity"
            getOptionLabel={(option) => option.displayValue ?? option}
            options={machineSizes}
            sx={{ width: '300px' }}
            onChange={(event, value) => {
              onValueChange(value);
            }}
            renderInput={(params) => <TextField {...params} label="Size (lbs)" />}
            value={selectedMachineSizeDisplay}
            isOptionEqualToValue={(option, value) => option.displayValue === value}
          />
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton, {
            disabled: !selectedMachineSize,
          })}
          disabled={!selectedMachineSize}
          onClick={onNext}
        >
          Next
        </button>
      </footer>
    </>
  );
};

export default MachineSizeSelection;
